import { DialogHeader, DialogTitle, DialogDescription } from "./ui/dialog";
import type { LucideIcon } from "lucide-react";

interface AuthDialogHeaderProps {
  icon: LucideIcon;
  title: string;
  description: string;
}

// Shared navy header for the auth dialogs (login/signup, forgot password,
// resend verification). Replaces the base64-grid gradient header that used
// to be copy-pasted into each of those surfaces.
export function AuthDialogHeader({ icon: Icon, title, description }: AuthDialogHeaderProps) {
  return (
    <div className="bg-[#0f1f3d] p-6 flex-shrink-0">
      <DialogHeader>
        <div className="flex items-center justify-center mb-4">
          <Icon className="w-10 h-10 text-[#d4af37]" aria-hidden="true" />
        </div>
        <DialogTitle className="text-2xl text-center text-white">
          {title}
        </DialogTitle>
        <DialogDescription className="text-center text-white/70">
          {description}
        </DialogDescription>
      </DialogHeader>
    </div>
  );
}
